import axios from "axios";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { url } from "../config";

const CollectionsContext = createContext();

const CollectionsProvider = ({ children }) => {
    const [loading, setLoading] = useState(true);

    const [collections, setCollections] = useState([]);
    const [collectionsForHomePage, setCollectionsForHomePage] = useState([]);

    async function getAll() {
        try {
            var { data } = await axios.get(`${url}/collections`);
            setCollections(data);
            console.log(collections);
            // only show a max of 4 on home page 
            setCollectionsForHomePage(data.slice(0, 4));
            setLoading(false);
        } catch (error) {
            console.error(error);
            return "err";
        }
    }

    async function getCollectionProducts(id) {
        try {
            var { data } = await axios.post(
                `${url}//collection/products/by-id`,
                {
                    id: id
                }
            );
            return data;
        } catch (error) {
            console.error(error);
            return "err";
        }
    }

    useEffect(() => {
        getAll();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // Memoized value of the authentication context
    const contextValue = useMemo(
        () => ({
            loading,
            collections,
            collectionsForHomePage,
            getCollectionProducts,
        }),
        [collections, loading] // eslint-disable-line react-hooks/exhaustive-deps
    );

    return (
        <CollectionsContext.Provider value={contextValue}>{children}</CollectionsContext.Provider>
    );
};

export const useCollections = () => {
    return useContext(CollectionsContext);
};

export default CollectionsProvider;